module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-30.41482bd9.svg";